import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'

import Question from 'modules/surveys/components/WriteResponse/Question'
import type { IQuestionGroup } from 'modules/surveys/store/models/QuestionGroup'

type QuestionProps = React.ComponentProps<typeof Question>

type QuestionWithCategory = IQuestionGroup['questions'][number]

interface Props {
  categoryName: string
  questionCategories: QuestionWithCategory[]
  formsWithCategory: Form[]
  optionsWithCategory: Record<string, QuestionProps['options']>
  isResponseValues?: boolean
  canReview?: boolean
}

const QuestionsWithCategory = ({
  categoryName,
  questionCategories,
  formsWithCategory,
  optionsWithCategory,
  isResponseValues,
  canReview = true,
}: Props) => {
  const sortedQuestionCategories = sortBy(
    questionCategories,
    (question: QuestionWithCategory) => question.position
  )

  return (
    <Box
      border={{
        top: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
    >
      <Box gap="s48" paddingTop="s24" paddingX="s24">
        <Text size="300" color="grey1000" weight="medium">
          {categoryName}
        </Text>
      </Box>
      <Box gap="s48" padding="s24">
        {sortedQuestionCategories.map((question) => {
          const form = find(
            formsWithCategory,
            (f) => f.get('field_id').value === question.custom_field.id
          )

          const field = question.custom_field

          if (!field || !form) return null

          return (
            <Box key={form.get('name').value} flexDirection="row" gap="s24" flexGrow>
              <Question
                fieldName={form.get('name').value}
                fieldType={form.get('field_type').value}
                formField={form.get('value')}
                mandatory={form.get('mandatory').value}
                minValue={+form.get('min_value').value} // +null => 0
                maxValue={+form.get('max_value').value} // +null => 0
                options={optionsWithCategory[field.id] ?? []}
                position={question.position + 1}
                readonly={isResponseValues || !canReview}
              />
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default QuestionsWithCategory
